<template>
  <b-row class="beneficios-info">
    <b-col>
      <label>Média</label>
      R$ {{ valores.media | number_format }}
    </b-col>
    <b-col>
      <label>Maior</label>
      R$ {{ valores.max | number_format }}
    </b-col>
    <b-col>
      <label>Menor</label>
      R$ {{ valores.min | number_format }}
    </b-col>
    <b-col>
      <label>Total</label>
      R$ {{ valores.total | number_format }}
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    valores: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.beneficios-info {
  font-size: 0.9em;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 3px;

  .col {
    border-right: 1px solid rgba(0, 0, 0, 0.05);

    &:last-of-type {
      border: none;
    }
  }

  label {
    font-size: 0.8em;
    margin-bottom: 0;
    display: block;
  }
}
</style>
